import React, {Component} from "react";
import axios from "axios";
import "react-responsive-modal/styles.css";
import {Link} from "react-router-dom";

class Sidebar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loggedInUser: null,
      showComponent: false,
      terminalDetails: [],
    };
  }

  componentDidMount() {
    axios
        .get(`getLoggedUserName?JSESSIONID=${sessionStorage.getItem('COOKIE')}`)
      .then((response) => {
        this.setState({ loggedInUser: response.data });
        console.log(
          "=== LOG_1 === Inside componentDidMount %s with data ",
          "User info",
          this.state.loggedInUser
        );
      })
      .finally(() => {})
      .catch((error) => {
        console.log("GOT ERROR HERE for Get LoggedIn User", error);
      });
  }

  handleClick = (e) => {
    e.preventDefault();
    axios({
      url: "downloadDayCloseReport?userid=" + this.state.loggedInUser, //your url
      method: "GET",
      responseType: "blob", // important
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "TerminalDayCloseSummary.xls"); //or any other extension
      document.body.appendChild(link);
      link.click();
    });
  };

  render() {

      const loader = {
          height: '700px',
          left: '40%',
          position: 'relative',
      };
    return (
      <div className="vertical-menu">
        <div className="navbar-brand-box">
          <a href="#" className="logo logo-dark">
            <span className="logo-sm">
              <img src="assets/images/logo-dark-sm.png" alt="" height="22" />
            </span>
            <span className="logo-lg">
              <img src="assets/images/logo-dark.png" alt="" height="18" />
            </span>
          </a>

          <a href="#" className="logo logo-light">
            <span className="logo-sm">
              <img src="assets/images/logo-light-sm.png" alt="" height="22" />
            </span>
            <span className="logo-lg">
              <img
                src="assets/images/icons/DataCenterLogo.png"
                style={{ width: "30%", height: "auto", background:"white"}}
                alt=""
              />
            </span>
          </a>
        </div>
        <div data-simplebar className="sidebar-menu-scroll">
          <div id="sidebar-menu" style={{position:"fixed", width:"250px", overflowY:"scroll",top:"60px",bottom:"0"}}>
            <ul className="metismenu list-unstyled" id="side-menu">
              <li className="menu-title">

              </li>
                  {<li>
                    <Link to="/termManagement#tb_terminal_mgmt" className="waves-effect">
                      <img src="assets/images/icons/msicon01.png" />
                      <span className="menu-item">Terminal Management</span>
                    </Link>
                  </li>}
                <li>
                    <Link to="/CashMonitoring">
                        <img src="assets/images/icons/msicon06.png" />
                        <span className="menu-item">Cash Monitoring</span>
                    </Link>
                </li>
              <li>
                <a href="#" className="waves-effect">
                  <img src="assets/images/icons/msicon02.png" />
                  <span className="menu-item">Reporting</span>
                </a>
                <ul className="sub-menu" aria-expanded="false">
                    {/*<!--FOR CA -!>*/}
                    <li>
                        <Link to="/C260Reporting">
                            C260 Report Summary
                        </Link>
                    </li>
                    <li>
                        <Link to="/C260RollUpReporting">
                            Int/Non-Interac Report
                        </Link>
                    </li>
                    <li>
                        <Link to="/DailyAdjustmentSummaryReporting">
                            Daily Adjustment Report
                        </Link>
                    </li>
                    <li>
                        <Link to="/TerminalBalanceSummaryReporting">
                            Terminal Balance Report
                        </Link>
                    </li>
                    {/*<!--FOR US -!>*/}
                   {/* <li>
                        <Link
                      to="#"
                      href="#"
                      onClick={this.handleClick}
                      target="_blank"
                      rel="noopener noreferrer"
                      download>Day Close Report</Link>
                    </li>
                  <li>
                    <Link to="/report">Cash Load Detail Report</Link>
                  </li>

                  <li>
                    <Link to="/achDetailByTerminal">
                      ACH Detail By TerminalReport
                    </Link>
                  </li>
                    <li>
                        <Link to="/POSPortfolioSummary">
                            Portfolio Monthly Summary - POS
                        </Link>
                    </li>
                    <li>
                        <Link to="/TerminalSurchargeSummary">
                            ATM Partner Monthly Summary
                        </Link>
                    </li>
                    <li>
                        <Link to="/portfolioMonthly">
                            Portfolio Monthly Summary
                        </Link>
                    </li>*/}
                    {/*<!--FOR CANADA -!>*/}
                    {/*<li>
                        <Link to="/dccMonthly">
                            DCC Monthly Summary
                        </Link>
                    </li>
                    <li>
                        <Link to="/profitMonthly">
                            Profit Monthly Summary
                        </Link>
                    </li>*/}

                </ul>
              </li>
              <li>
                <Link to="/keyManagement#tb_key_mgmt" className="waves-effect">
                  <img src="assets/images/icons/msicon03.png" />
                  <span className="menu-item">Key Management</span>
                </Link>
              </li>
                {/*<li>
                    <Link to="/MackeyManagement#tb_key_mgmt" className="waves-effect">
                        <img src="assets/images/icons/msicon03.png" />
                        <span className="menu-item">Mac Key Management</span>
                    </Link>
                </li>*/}
              {/*<li>
                <Link to="#" className="waves-effect">
                  <img src="assets/images/icons/msicon04.png" />
                  <span className="menu-item">Alert Plus</span>
                </Link>
              </li>
              <li>
                <Link to="/userMgmt" className="waves-effect">
                  {" "}
                  <img src="assets/images/icons/msicon05.png" /> User Management
                </Link>
              </li>*/}
              <li>
                <Link to="/accountManager" className="waves-effect">
                  <img src="assets/images/icons/msicon06.png" />
                  <span className="menu-item">Account Manager</span>
                </Link>
              </li>
              <li>
                <Link to="/transactionLookup" className="waves-effect">
                  <img src="assets/images/icons/msicon07.png" />
                  <span className="menu-item">Transaction Lookup</span>
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    );
  }
}

export default Sidebar;
